import { SET_LANGUAGE } from './types';
const initialState = {
    language: '',
};
export const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return {
                language: action.language,
            };
        default:
            return state;
    }
};
